<template>
  <b-modal id="searchemail" centered size="lg" ref="searchEmailModal" class="modal-backdrop" no-close-on-esc
    no-close-on-backdrop>
    <template slot="modal-header" class="mx-auto">
      <h5 class="modal-title">Add User</h5>
    </template>
    <template slot="default">
      <p>Enter the email address of the user you would like to add to the account.</p>
      <p>
        <span class="errorMessage" v-if="$v.form.$error && !$v.form.searchedEmailId.required">User email cannot be
          blank.</span>
        <span class="errorMessage"
          v-if="$v.form.$error && !$v.form.searchedEmailId.isValidEmail && $v.form.searchedEmailId.required">Enter
          correct email.</span>
      </p>
      <div class="row">
        <div class="col-md-2">
          <label>
            <span class="requiredinput">*</span>
            User email:
          </label>
        </div>
        <div class="col-md-10"
          :class="{ 'hasError': $v.form.searchedEmailId.$error, 'noError': $v.form.searchedEmailId.$error == false }">
          <input type="text" ref="searchedEmailId" style="width:300px;" class="pl-2 pr-2"
            v-model.lazy="form.searchedEmailId" tabindex="1" v-sanitize-html="form.searchedEmailId" />
        </div>
      </div>
    </template>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button class="um-btn" @click="cancelChanges()" tabindex="3">Cancel</b-button>
      <b-button class="um-btn" @click="setUserAction($event)" tabindex="2">Next</b-button>
    </template>
    <ActivateUser :isNewUser="isNewUser" :userEmailId="userFormDetail.searchedEmailId" :accountName="accountName"
      :accountNumber="accountNumber" @OnCreateUserModalCancel="CloseSearchEmailModal" :accountId="accountId"
      :searchedUserDetail="searchedUserDetail" :activateButtonText="activateButtonText"
      :activateUserMessage="activateUserMessage"></ActivateUser>
    <CreateUser v-if="isSearchPerform == true" :isNewUser="isNewUser" :userEmailId="userFormDetail.searchedEmailId"
      :accountName="accountName" :accountNumber="accountNumber" @OnCreateUserModalCancel="CloseSearchEmailModal"
      :accountId="accountId"></CreateUser>
    <ErrorMessage :errorMessage="errorMsg" callbackOnClose="cancelChanges" @cancelChanges="cancelChanges"></ErrorMessage>
    <UserDisableError :message="errorMsg" :headerMessage="headerMessage"></UserDisableError>
    <CreateAdfsUser :isNewUser="isNewUser" :userEmailId="userFormDetail.searchedEmailId" :accountName="accountName"
      :accountNumber="accountNumber" :accountId="accountId" :searchedUserDetail="searchedUserDetail"
      @OnCreateAdfsUserModalCancel="CloseSearchEmailModal" :actionFromEdit="false"></CreateAdfsUser>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
  </b-modal>
</template>
<script>
import { required, minLength } from "vuelidate/lib/validators";
import CreateUser from "./CreateUser";
import ErrorMessage from "./shared/ErrorMessage";
import UserDisableError from "./shared/UserDisableError";
import service from "../services/api.services";
import applicationSetting from "./ApplicationSetting";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { eventbus } from "../main";
import ActivateUser from "./shared/ActivateUser";
import CreateAdfsUser from "./shared/CreateAdfsUser";
export default {
  name: "SearchEmail",
  components: {
    CreateUser,
    ErrorMessage,
    applicationSetting,
    Loading,
    ActivateUser,
    CreateAdfsUser,
    UserDisableError
  },
  data() {
    return {
      form: {
        searchedEmailId: ""
      },
      searchedUserDetail: null,
      adminAccounts: null, //loggedInUserDetail: null,
      loggedInUserName: this.$store.getters.username,
      isLoading: false,
      fullPage: true,
      isValid: false,
      isSupportNumbersVisible: false,
      errorMsg:
        "Sorry, you do not have the required permission to add the user to this account.",
      isNewUser: true,
      isAlreadyAssociated: false,
      isSearchPerform: true,
      isEnabled: true,
      adfsUserDetails: null,
      headerMessage: "",
      activateButtonText: "",
      activateUserMessage: ""
    };
  },
  validations: {
    form: {
      searchedEmailId: {
        required, minLength: minLength(1), isValidEmail: function (value) {
          return this.validateEmail(value);
        },
      }
    }
  },
  props: {
    accountNumber: String,
    accountName: String,
    accountId: String
  },
  computed: {
    userFormDetail: {
      get: function () {
        return this.form;
      },
      set: function (newvalue) {
        this.form = newvalue;
      }
    }
  },
  methods: {
    validateEmail(email) {
      if (/^(?:[a-z0-9!_-]+(?:\.[a-z0-9!_-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)$/.test(email)) {
        return true;
      } else {
        return false;
      }

    },
    clearForm: function () {
      var that = this;
      setTimeout(function () {
        that.form.searchedEmailId = "";
        that.$v.form.$reset();
      }, 10);
    },
    CloseSearchEmailModal: function () {
      this.isLoading = false;
      this.clearForm();
      (this.isValid = false),
        (this.errorMsg =
          "Sorry, you do not have the required permission to add the user to this account."),
        (this.isNewUser = true),
        (this.isAlreadyAssociated = false);
      this.form.searchedEmailId = "";
      this.$bvModal.hide("createadfsuser");
      this.$refs["searchEmailModal"].hide();
      this.isDirty = false;
    },
    emitMethod() {
      eventbus.$emit(
        "setuserDetails",
        this.$store.getters.searchedUserDetail,
        this.isNewUser
      );
      eventbus.$emit("setAdfsuserDetails", this.adfsUserDetails);
      if (
        typeof this.accountContactRelation !== "undefined" &&
        this.accountContactRelation != null
      )
        eventbus.$emit("setRolesAndPermissions", this.accountContactRelation);
    },

    cancelChanges: function () {
      this.clearForm();
      this.isLoading = false;
      (this.isValid = false),
        (this.errorMsg =
          "Sorry, you do not have the required permission to add the user to this account."),
        (this.isNewUser = true),
        (this.isAlreadyAssociated = false);
      this.clearForm();
      this.$bvModal.hide("searchemail");
    },

    setUserAction: function ($event) {
      $event.target.blur();
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      } else {
        var that = this;
        this.isLoading = true;
        service
          .SetUserAction(this.form.searchedEmailId, this.accountId)
          .then(result => {
            that.isLoading = false;
            if (result.data.errorMessage != null && result.data.errorMessage != "") {
              that.isSupportNumbersVisible = result.data.errorMessage.includes("This email address is associated with an inactive user");
              that.errorMsg = that.isSupportNumbersVisible ?
                "<b>" + result.data.errorMessage + "</b>" + (that.$store.getters.errorMessage != null ? that.$store.getters.errorMessage : "")
                : result.data.errorMessage;
              that.headerMessage = result.data.errorHeaderMessage
            } else {
              //Set required Flags
              that.isNewUser = result.data.isNewUser;
              that.isAlreadyAssociated =
                result.data.isUserAlreadyAssociatedToAccount;
              that.isValid = result.data.isUserAdmin;

              //Set ADFS User Detail
              that.adfsUserDetails = result.data.adfsUserDetail;

              //Set Contact Detail
              that.searchedUserDetail = result.data.sfContactDetail;
              if (!that.isNewUser && that.searchedUserDetail && result.data.adfsUserDetail)
                that.searchedUserDetail.middleInitial = result.data.adfsUserDetail.middleInitial;
              if (that.searchedUserDetail != null)
                that.searchedUserDetail.adfsGuid; //need to verify this statement

              that.$store.dispatch(
                "setSearchedUserDetail",
                result.data.sfContactDetail
              );
              if (
                result.data.accountContactRelationModel
                  .accountContactRelationList != null &&
                result.data.accountContactRelationModel
                  .accountContactRelationList.length > 0
              ) {
                that.accountContactRelation = result.data.accountContactRelationModel.accountContactRelationList.find(
                  x => x.cadebillAccountNo == this.accountNumber
                );
              }

              //Activate user popup details
              if (that.searchedUserDetail && that.searchedUserDetail.userCommunityType == "Partner User" && !that.searchedUserDetail.isCustomerCommunityUser) {
                that.activateUserMessage = "This user is currently disabled. Select Enable to continue";
                that.activateButtonText = "Enable"
              }
              else {
                that.activateUserMessage = "This user is currently disabled. Select Enable and Continue to activate the user on this account";
                that.activateButtonText = "Enable and Continue"
              }
              that.emitMethod();
            }

            //Set User Action
            that.$bvModal.show(result.data.action);
          })
          .catch(error => {
            that.isLoading = false;
            console.log(error);
            that.accessibleApplicationList = [];
          });
      }
    }
  }
};
</script>
<style scoped>
.adduserbtn {
  margin-left: 0.8em;
  background-color: #2c87f0;
  border: 1px solid #2c87f0;
  height: 2.6em;
  border-radius: 5px;
  font-size: 0.8em;
  color: white;
  width: 5.2em;
}
</style>
<style>
.requiredinput {
  color: red;
}

.hasError label {
  color: red !important;
}

.hasError input {
  border-color: red !important;
}

.noError input {
  border-color: white !important;
}

.modal-backdrop {
  opacity: 0.5;
  transition: opacity 0.2s;
  border-color: red;
}

.modal-title {
  margin: auto;
}

.errorMessage {
  color: red;
  font-size: 0.8em;
  font-weight: 500;
}
</style>
